import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import service from '@/helper/const'
import FileDownloadButton from '../../file-download-button/index.vue'
import * as UserType from '@/helper/UserType'

export default {
  components: {
    FileDownloadButton
  },
  props: {
    value: {
      required: true,
      type: Object,
      default: false
    }
  },
  data () {
    return {
      userType: UserType,
      dialog: false,
      selected: [],
      isLoading: false,
      pagination: {},
      headers: [
        { text: 'Ações', value: 'idCallManager', align: 'center' },
        { text: 'Usuário', value: 'nameUser', align: 'left' },
        { text: 'Status', value: 'status', align: 'left' },
        { text: 'CPF/CNPJ', value: 'cpf', align: 'left' },
        { text: 'Nome', value: 'name', align: 'left' },
        { text: 'Data/Hora início', value: 'startTime', align: 'left' },
        { text: 'Data/Hora fim', value: 'endTime', align: 'left' },
        { text: 'Origem', value: 'origin', align: 'left' },
        { text: 'Valor Cobrado', value: 'callValue', align: 'right' }
      ]
    }
  },
  computed: {
    ...mapGetters([
      'getterAccount',
      'getterHierarchicalDetails',
      'getterSelectedCallManager'
    ]),
    reportsHierarquicalCallManager () {
      return this.getterHierarchicalDetails
    }
  },
  mounted () {
    this.getHierarchicalDetails()
    this.dialog = true
  },
  methods: {
    ...mapActions([
      'actionGetHierarchicalDetails'
    ]),
    linkToDownload (type, item) {
      let result = ''

      if (type === 'selected') {
        result = `${service.SERVICE_DOWNLOAD_SPREADSHEET_ALL}?sortBy=StartTime&descending=true&page=1&size=10&idProviderFlow=${this.value.idProviderFlow}&startDate=${`${moment(this.startDate).format('YYYY-MM-DD')}T00:00:00`}&endDate=${`${moment(this.endDate).format('YYYY-MM-DD')}T23:59:59`}&name=&cpf=&idClient=${this.getterAccount.idClient}`
      } else {
        result = `${service.SERVICE_DOSSIE}/${item.idProviderFlow}/${item.idCallManager}`
      }

      return result
    },
    formatDate (date) {
      return moment(date).format('DD/MM/YYYY [às] HH:mm:ss')
    },
    closeModal () {
      this.dialog = false

      setTimeout(() => {
        this.$emit('input', null)
      }, 300)
    },
    async getHierarchicalDetails () {
      return this.actionGetHierarchicalDetails(this.getterSelectedCallManager.idCallManager)
    }
  }
}
